import { reportUndloadingSagaWatcher } from './ReportUnloading/saga';
import { reportLoadingSagaWatcher } from './ReportLoading/saga';
import { report2359SagaWatcher } from './Report2359/saga';
import { blackListSagaWatcher } from './ReportSpecialList/saga';

export const reportsSaga = [
  reportUndloadingSagaWatcher,
  reportLoadingSagaWatcher,
  report2359SagaWatcher,
  blackListSagaWatcher,
];
